import { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { useForm } from 'react-hook-form';
import { Box, Button, FormControl, Grid, Stack, TextField } from '@mui/material';
import { ForwardToInbox, HighlightOff } from '@mui/icons-material';
import ModalBase from '../../Controls/ModalBase';
import { enviarDenuncia } from '../../../services/Afiliado/Autorizaciones';
import { LoadingButton } from '@mui/lab';
import { useDenuncias } from '../hooks/useDenuncias';

export const EnviarDenunciaModal = ({ title, subtitle, autorizacion, ...props }) => {
  // const {denuncia, setDenuncia} = useDenuncias();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    defaultValues: {
      idAutorizacion: autorizacion?.id || null,
      correo: autorizacion?.correo || '',
    },
  });

  useEffect(() => {}, []);

  const onEnviarAutorizacion = async (data, event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const res = await enviarDenuncia(data);
      if (res) {
        props.setAutorizacion(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    props.onCancelar();
  };

  const DrawerForm = (
    <form onSubmit={handleSubmit(onEnviarAutorizacion)} noValidate>
      <FormControl fullWidth={true} variant='outlined' margin='normal'>
        <TextField
          type='email'
          label='Correo electrónico'
          variant='standard'
          fullWidth
          error={!!errors.correo}
          helperText={errors.correo ? errors.correo.message : ''}
          {...register('correo', {
            required: {
              value: true,
              message: 'El campo es requerido',
            },
            pattern: {
              // patrón sencillo y fiable para emails: local@domain.tld
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: 'El formato no es correcto (nombre@dominio.com)',
            },
            maxLength: {
              value: 254,
              message: 'El correo es demasiado largo',
            },
            validate: (v) => (v || '').trim() !== '' || 'El campo no puede estar vacío',
          })}
        />
      </FormControl>

      <Box sx={{ width: '100%', padding: '10px' }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1, sm: 2 }}
          justifyContent={{ xs: 'center', sm: 'flex-end' }}
        >
          <Button
            variant='contained'
            startIcon={<HighlightOff />}
            color='neutral'
            onClick={handleClose}
            // fullWidth
          >
            Cancelar
          </Button>
          <LoadingButton
            // fullWidth={true}
            variant='contained'
            size='medium'
            color='primary'
            startIcon={<ForwardToInbox />}
            type='submit'
            loading={loading}
          >
            Enviar
          </LoadingButton>
        </Stack>
      </Box>
    </form>
  );

  const popUpEnviar = (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography gutterBottom>
          {subtitle || `Correo electrónico del destinatario de la solicitud`}
        </Typography>
        {DrawerForm}
      </Grid>
    </Grid>
  );

  return (
    <Box sx={{ width: '100%' }}>
      <ModalBase
        fullWidth={false}
        open={true}
        content={popUpEnviar}
        title={title || 'Enviar Solicitud de Reclamo'}
        setAutorizacion={props.setAutorizacion}
      />
    </Box>
  );
};
